<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="pull-right">
                    <router-link to="/">Terug naar lijst</router-link>
                </div>
                Note
            </div>
            <div class="panel-body">
                <form class="form-horizontal" role="form" method="POST" v-on:submit.prevent="handleNoteSubmit()">

                    <div class="form-group">
                        <label for="title" class="col-md-4 control-label">Titel</label>

                        <div class="col-md-6">
                            <input id="title" type="text" class="form-control" name="title" v-model="note.title" required autofocus>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="text" class="col-md-4 control-label">Tekst</label>

                        <div class="col-md-6">
                            <textarea id="text" class="form-control" name="text" required rows="10" v-model="note.text"></textarea>

                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-md-8 col-md-offset-4">
                            <button type="submit" class="btn btn-primary">Opslaan</button>
                            <button type="button" class="btn btn-danger" v-on:click="deleteNote()">Verwijderen</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="alert alert-success" v-if="showMessage">
            <strong>{{ message }}</strong>
        </div>
    </div>
</template>

<script>
    export default {
        name: "newOrEdit",
        data () {
            return {
                id: 0,
                note: {},
                message: '',
                showMessage: false
            }
        },
        created () {
            this.id = this.$route.params.id
        },
        mounted () {
            axios.get('/releasenote/' + this.id).then(response => {
                console.log(response)
                if (response.data.error) {
                    alert(response.data.error)
                } else if (response.data.result) {
                    this.note = response.data.result
                }
            });
        },
        methods: {
            deleteNote() {
                if( ! confirm( 'Zeker weten?' ) )return;
                axios.delete('/releasenote/' + this.id).then(response => {
                    console.log(response)
                    if (response.data.error) {
                        alert(response.data.error)
                    } else if (response.data.result) {
                        this.message = response.data.result + ' U wordt omgeleid'
                        this.showMessage = true
                        setTimeout(() => {
                            this.$router.push('/')
                        }, 1000)

                    }
                });
            },
            handleNoteSubmit () {
                console.log('/releasenote/' + this.id, this.note)
                axios.put('/releasenote/' + this.id, this.note).then(response => {
                    console.log(response)
                    if (response.data.error) {
                        alert(response.data.error)
                    } else if (response.data.result) {
                        this.message = response.data.result
                        this.showMessage = true
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>